'use strict';

// import modalController from './ddjjdetalle.modal.controller.js';
// import modalTemplate from './ddjjdetalle.modal.html';

import modalobsController from './ddjjdetalle.modal.obs.controller.js';
import modalobsTemplate from './ddjjdetalle.modal.obs.html';

class DdjjdetalleController {
  constructor(Message, $scope, $log, Modal, Storage, DataService, Sidenav, $window, Loading) {
    'ngInject';
    this.Message = Message;
    this.$scope = $scope;
    this.$log = $log;
    this.Modal = Modal;
    this.Storage = Storage;
    this.DataService = DataService;
    this.Sidenav = Sidenav;
    this.$window = $window;
    this.Loading = Loading;
  }

  $onInit() {
    // this.$log.log(this)
    this.Loading.show('Cargando', true);
    this.data = this.Storage.get('selloBolivia');
    if (!this.data && !angular.isObject(this.data)) {
      this.volver();
    }

    this.urls = {};
    this.caeb= {};
    var this_ = this;

    this.DataService.pdfO(`cert_sello_bolivia/productos_shb/ddjj_sello_bolivia/${this.data.id_sello_bolivia}`)
    .then( response => {
      if (response) {
        this.urls.producto = response;
        this.iframe_url = response;
        this_.Loading.hide();
        // this.cargarCertificado();
      }
    });

    if (this.data.ddjj_estado == 'PENDIENTE') {
      // this.cargarCaeb();
    }
    if (this.data.fid_caeb) {
      this.cargarCaebByid(this.data.fid_caeb);
    }

    this.$scope.$on('app_adm_sello_modal_obs_success', () => { this.volver(); });
  }

  asignarCaeb(caeb) {
    var data = { id_caeb: caeb.id_caeb };
    this.DataService.put('certificaciones/' + this.data.id_certificacion + '/actividades_economicas/' + this.data.id_producto + '/caeb', data)
    .then(response => {
      if (response) {
        this.data.fid_caeb = caeb.id_caeb;
        this.Storage.set('selloBolivia', this.data);
      }
    });
  }

   cargarCaebByid(idCaeb) {
    if (idCaeb !== null && angular.isDefined(idCaeb)) {
      this.DataService.get(`clasificadores/` + idCaeb)
      .then(response => {
        if (response) {
          this.caeb.selected = response;
        }
      });
    }
  }

  cargarCaeb() {
    var padre;
    this.listadoCaeb = [];
    this.DataService.get(`clasificadores/subclases`)
    .then(response => {
      this.$log.log(this);
      if (response) {
        this.getListadoCaeb = response;
        this.getListadoCaeb.forEach( it => {
          it.xdescripcion = it.codigo.toLowerCase() + ' - ' + it.descripcion.toLowerCase().replace(/á/g,'a').replace(/é/g,'e').replace(/í/g,'i').replace(/ó/g,'o').replace(/ú/g,'u');
          padre = it.padre;
          it.xdescripcion2 = padre.codigo.toLowerCase() + ' - ' + padre.descripcion.toLowerCase().replace(/á/g,'a').replace(/é/g,'e').replace(/í/g,'i').replace(/ó/g,'o').replace(/ú/g,'u');
          padre = padre.padre;
          it.xdescripcion3 = padre.codigo.toLowerCase() + ' - ' + padre.descripcion.toLowerCase().replace(/á/g,'a').replace(/é/g,'e').replace(/í/g,'i').replace(/ó/g,'o').replace(/ú/g,'u');
          padre = padre.padre;
          it.xdescripcion4 = padre.codigo.toLowerCase() + ' - ' + padre.descripcion.toLowerCase().replace(/á/g,'a').replace(/é/g,'e').replace(/í/g,'i').replace(/ó/g,'o').replace(/ú/g,'u');
          padre = padre.padre;
          it.xdescripcion5 = padre.codigo.toLowerCase() + ' - ' + padre.descripcion.toLowerCase().replace(/á/g,'a').replace(/é/g,'e').replace(/í/g,'i').replace(/ó/g,'o').replace(/ú/g,'u');
        })
        this.refreshResult();
      }
    });
  }

  refreshResult (textSearch) {
    var arrCaebs;
    if (this.getListadoCaeb) {
      // this.$log.log('textSearch='+textSearch);
      arrCaebs = angular.copy(this.getListadoCaeb);
      if (textSearch) {
        textSearch = textSearch.toLowerCase().replace(/á/g,'a').replace(/é/g,'e').replace(/í/g,'i').replace(/ó/g,'o').replace(/ú/g,'u');
        arrCaebs = arrCaebs.filter( it => {
          return it.xdescripcion.indexOf(textSearch)!=-1 ||
          it.xdescripcion5.indexOf(textSearch)!=-1 ||
          it.xdescripcion4.indexOf(textSearch)!=-1 ||
          it.xdescripcion3.indexOf(textSearch)!=-1 ||
          it.xdescripcion2.indexOf(textSearch)!=-1;
        })
      }
      if (arrCaebs.length > 20) {
        arrCaebs = arrCaebs.splice(0, 20);
      }
      this.listadoCaeb = arrCaebs;
    }
  }


  cargarCertificado() {
    this.DataService.pdfO(`cert_sello_bolivia/productos_shb/ddjj_sello_bolivia/${this.data.id_sello_bolivia}/previsualizar_certificado`)
    .then( response => {
      if (response) {
        this.urls.certificado = response;
        // this.data.estado = 'APROBADO';
        // this.Storage.Set('selloBolivia', this.data);
        // this.iframe_url = response;
        // this.urls.sw = true;
      }
    });
  }

  changePdf() {
    if (this.urls.sw) {
      this.urls.sw = false;
      this.iframe_url = this.urls.producto;
    } else {
      this.urls.sw = true;
      this.iframe_url = this.urls.certificado;
    }

  }

  esEdge() {
    var userAgent = this.$window.navigator.userAgent;
    var ieEDGE = userAgent.match(/Edge/g);
    var ie = userAgent.match(/.NET/g); // IE 11+
    var oldIE = userAgent.match(/MSIE/g);
    return ie || oldIE || ieEDGE;
  }

  descargarPdf(ruta, nombre) {
    this.DataService.pdfOfile(ruta, {})
    .then((response) => {
      if (response) {
        nombre = nombre.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '_');//todos los caracteres
        //let nombreEmpresa = string = string.replace(/[^a-zA-Z0-9]/g,'_');//Solo numeros o letras
        var fileName = "" + nombre + ".pdf";
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.href = response;
        a.download = fileName;
        a.click();
        this.Message.success('Su documento esta siendo descargado.');
      }
    });
  }

  isEstado(cad) {
    cad = cad.split(', ')
    for (var i = 0; i < cad.length; i++) {
      if (cad[i]===this.data.ddjj_estado)
        return true;
    }
    return false;
  }

   descargarCertificado() {
    var ruta = `certificaciones/generar_certificado/` + this.certificacion.id_certificacion;
    if (this.certificacion.ddjj_estado === 'APROBADO') {
      ruta = `certificaciones/mostrar_certificado/` + this.certificacion.id_certificacion;
    }
    this.$log.log('Url de descarga file = ', ruta);
    this.DataService.pdfOfile(ruta, {})
    .then((response) => {
      if (response) {
        let nombreEmpresa = angular.copy(this.unidad_productiva.razon_social);
        nombreEmpresa = nombreEmpresa.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '_');//todos los caracteres
//        let nombreEmpresa = string = string.replace(/[^a-zA-Z0-9]/g,'_');//Solo numeros o letras
        var fileName = "certificado_" + nombreEmpresa + ".pdf";
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.href = response;
        a.download = fileName;
        a.click();
      }
    });
  }

  observar(rechazar) {
    this.data.accion = rechazar||0;
    this.Modal.show({
      template: modalobsTemplate,
      controller: modalobsController,
      data: this.data,
      size: 'lg'
    });
  }

  aprobar() {
    // this.$log.log('aprobar sello');
    //Comentando metodo de aprobar, por si se aprueba en esta instancia
    if (angular.isDefined(this.data.fid_caeb)) {
      this.Modal.confirm('¿Está seguro de aprobar el producto?', () => {
        var dataEnv = {
          estado: 'APROBADO',
          id_sello_bolivia: this.data.id_sello_bolivia,
          fid_caeb: this.data.fid_caeb, // REQ
          observacion: ''
        };
        this.DataService.put(`cert_sello_bolivia/evaluar_shb`,dataEnv)
        .then( response => {
          if (response) {
            this.Message.success();
            this.data.ddjj_estado = 'APROBADO';
            this.Storage.set('selloBolivia', this.data);
          }
        });
      });
    } else {
      this.Message.error("Debe seleccionar el CAEB para poder aprobar");
    }

  }

  volver() {
    this.Sidenav.path('autorizaciones');
  }

}

export default DdjjdetalleController;



// WEBPACK FOOTER //
// ./src/app/components/admin/sellobolivia/ddjjdetalle/ddjjdetalle.controller.js